import type { ReactNode } from "react";
import { ChevronRight, Trash2 } from "lucide-react";

interface ChildRowProps {
  icon: ReactNode;
  code: string;
  meta?: string;
  chip?: ReactNode;
  onOpen: () => void;
  onDelete?: () => void; // Exclusão inline; ausente em modo leitura.
}

// Linha de filho reutilizável (listas de cartões/sensores no painel de detalhe).
export function ChildRow({ icon, code, meta, chip, onOpen, onDelete }: ChildRowProps) {
  return (
    <div className="flex items-center justify-between gap-2 rounded-md border border-border-subtle bg-card px-3 py-2 hover:border-border-default">
      <button
        type="button"
        onClick={onOpen}
        className="flex min-w-0 flex-1 items-center gap-2 text-left"
      >
        <span className="shrink-0 text-text-tertiary">{icon}</span>
        <span className="truncate font-mono text-[13px] text-text-primary">{code}</span>
        {chip}
        {meta && <span className="truncate text-[12px] text-text-secondary">{meta}</span>}
      </button>
      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          aria-label={`Abrir ${code}`}
          onClick={onOpen}
          className="rounded p-1 text-text-tertiary hover:bg-bg-muted-rd hover:text-text-primary"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
        {onDelete && (
          <button
            type="button"
            aria-label={`Excluir ${code}`}
            onClick={onDelete}
            className="rounded p-1 text-text-tertiary hover:bg-rd-danger-50 hover:text-rd-danger-700"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
